import { Modal, ModalBody, Spinner } from "reactstrap"
import { useIntl } from "react-intl"

const Loading = () => {
  const intl = useIntl()

  return (
    <Modal
      isOpen
      className="modal-dialog-centered modal-sm"
      modalClassName="modal-primary"
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center">
          <strong>{intl.formatMessage({ id: "loading" })}...</strong>
          <Spinner color="primary" />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default Loading
